import { PrintLogo } from "@/components/print/print-primitives.tsx";
import { Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PrintHeaderProps {
  title: ReactNode;
  children?: ReactNode;
  meta?: ReactNode;
}

export function PrintHeader({ title, children, meta }: PrintHeaderProps) {
  return (
    <Stack direction="horizontal" justify="between" items="start" gap="lg">
      <Stack gap="smd">
        <PrintLogo className="h-8 w-8" />
        <Stack gap="xs">
          <Text className="text-3xl text-title">{title}</Text>
          {children}
        </Stack>
      </Stack>
      {meta && (
        <Stack gap="sm" items="end" className="pt-1 text-right">
          {meta}
        </Stack>
      )}
    </Stack>
  );
}
